<template>
  <audience-authorization edit-permission="aiTrain:permission:edit" />
</template>

<script>
import AudienceAuthorization from '../common/AudienceAuthorization'

export default {
  name: 'AiTrainPermission',
  components: { AudienceAuthorization }
}
</script>
